import { render, staticRenderFns } from "./AddTextStamp.vue?vue&type=template&id=dd4ed45c&scoped=true&"
import script from "./AddTextStamp.vue?vue&type=script&lang=js&"
export * from "./AddTextStamp.vue?vue&type=script&lang=js&"
import style0 from "./AddTextStamp.vue?vue&type=style&index=0&id=dd4ed45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ed45c",
  null
  
)

export default component.exports